import React, { useState, useContext, useRef, useEffect, useCallback } from "react";
import Header from "../../Component/Header"
import { ApiService } from "../../Component/services/apiServices";
import constants from "../../Component/services/constants";
import Skeleton from "react-loading-skeleton";
import DataContext from "../../Component/context";
import AddItemModal from "../../Component/Modals/add_Item";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "react-js-loader";
import moment from 'moment-timezone';
import AccountHeader from "../../Component/Header/account_header";
const SearchResult = () => {
    const timeZone = "Australia/Sydney";
    const [productData, setproductData] = useState([]);
    const [isLoadingProducts, setIsLoadingProducts] = useState(true)
    const navigate = useNavigate()
    const contextValues = useContext(DataContext);
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [cart, setCart] = useState(() => {
        return JSON.parse(localStorage.getItem('CART_SESSION')) || [];
    });
    const [loadingItemId, setLoadingItemId] = useState(null); // Tracks loading state for individual items
    const { slug } = useParams()
    const didMountRef = useRef(true);

    const getSearch = useCallback(() => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        if (slug.length > 2) {
            const timeout = setTimeout(() => {
                const dataString = { query: slug };

                ApiService.postData('get-search-data', dataString).then((res) => {
                    if (res.status === 'success') {
                        setproductData(res.data);
                        setIsLoadingProducts(false);
                    } else {
                        setIsLoadingProducts(false);
                    }
                }).catch(() => {
                    setIsLoadingProducts(false);
                });
            }, 500);
            setDebounceTimeout(timeout);
        } else {
            setproductData([]);
        }
    }, [slug, debounceTimeout]);

    const addItemModal = () => {
        contextValues.setToggleItemAddModal(!contextValues.toggleItemAddModal)
    }

    const updateCartInSession = (updatedCart) => {
        localStorage.removeItem("CART_SESSION");
        localStorage.removeItem("COUPON_SESSION");
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
        setCart(updatedCart);
        setTimeout(() => {
            setLoadingItemId(null)
        }, 500);
    };

    const gotocheckout = () => {
        window.location.href = "/checkout";
    }

    const onModalOpen = async (item) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || []
        if (item.product_type === 0) {
            setLoadingItemId(item.product_id)
            const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
            let updatedCart;
            if (existingItem) {
                updatedCart = cart.map(cartItem =>
                    cartItem.product_id === item.product_id
                        ? { ...cartItem, quantity: cartItem.quantity + 1 }
                        : cartItem
                );
            } else {
                let today = moment().tz(timeZone).format('YYYY-MM-DD');
                let currentDay = moment().tz(timeZone).format('dddd');
                let uniqueSessionId = crypto.randomUUID();
                let schedule = getScheduleTime(today)
                if (schedule === '') {
                    today = moment().tz(timeZone).add(1, 'day').format('YYYY-MM-DD');
                    currentDay = moment().tz(timeZone).add(1, 'day').format('dddd');
                    schedule = getScheduleTime(today)
                }

                updatedCart = [
                    ...cart,
                    {
                        product_id: item.product_id,
                        product_day: currentDay,
                        product_selected_day: currentDay,
                        product_selected_date: today,
                        product_uniqueid: item.product_uniqueid,
                        product_name: item.product_name,
                        product_image: item.product_image,
                        product_price: item.product_price,
                        product_selling_price: item.product_selling_price,
                        product_discount: item.product_discounts,
                        product_type: item.product_type,
                        product_category_name: item.product_category_name,
                        product_tiffin_items: {},
                        product_slug: item?.product_slug,
                        addon_amount: 0,
                        addon_item_names: item.product_category_name,
                        quantity: 1,
                        product_sesion_id: uniqueSessionId,
                        product_time: schedule,
                    },
                ];
            }
            updateCartInSession(updatedCart);
        } else {
            contextValues.setSelectedProduct(item);
            addItemModal();
        }
    };

    const getScheduleTime = (newDate = moment().tz(timeZone).format("YYYY-MM-DD")) => {
        const today = moment().tz(timeZone).format('YYYY-MM-DD');
        const selectedDate = newDate;

        if (today !== selectedDate) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        if (!contextValues?.settingData) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues.settingData;
        const currentTime = moment().tz(timeZone).format('HH:mm:ss');

        const isDelivery = contextValues.orderRecieveStatus === 'delivery';
        const lunchEnd = isDelivery ? lunch_end_time : pickup_lunch_end_time;
        const dinnerEnd = isDelivery ? dinner_end_time : pickup_dinner_end_time;

        const schedule = currentTime < lunchEnd ? 'lunch' : currentTime < dinnerEnd ? 'dinner' : '';
        contextValues.setMenuSchedule(schedule);
        return schedule;
    };

    const ItemButton = ({ item, cart, onModalOpen, updateCart }) => {
        const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
        const handleAddToCart = () => {
            onModalOpen(item);
        };

        const handleRemoveFromCart = () => {
            let updatedCart = [...cart];
            setLoadingItemId(item.product_id)
            if (existingItem) {
                if (existingItem.quantity > 1) {
                    updatedCart = cart.map(cartItem =>
                        cartItem.product_id === item.product_id
                            ? { ...cartItem, quantity: cartItem.quantity - 1 }
                            : cartItem
                    );
                } else {
                    updatedCart = updatedCart.filter(cartItem => cartItem.product_id !== item.product_id);
                }
                updateCart(updatedCart);
            }
        };

        return (
            existingItem && item.product_type === 0 ? (
                <>
                    <span onClick={handleRemoveFromCart}><i className="ri-subtract-line"></i></span>
                    <span>{existingItem.quantity}</span>
                    <span onClick={handleAddToCart}><i className="ri-add-line"></i></span>
                </>
            ) : (
                <>
                    {item.product_type === 1 ? <><span onClick={handleAddToCart}>ADD</span>
                        <span className="plusicon"><i className="ri-add-line"></i></span></>
                        : <span onClick={handleAddToCart}>ADD</span>}
                </>
            )
        );
    };

    useEffect(() => {
        if (didMountRef.current) {
            getSearch()
        }
        didMountRef.current = false;
    }, [getSearch]);

    const sellingPrice = (item) => {
        if (item.product_type === 1) {
            if (item.has_many_cs_product_week_day.length > 0) {
                const day = moment().tz(timeZone).format('dddd');
                const dayData = item.has_many_cs_product_week_day.filter((dayitem) => dayitem.pwd_name === day);
                if (dayData.length > 0) {
                    return dayData[0].pwd_selling_price;
                } else {
                    return item.has_many_cs_product_week_day[0].pwd_selling_price;
                }
            }
        } else {
            return item.product_selling_price;
        }
    }

    const mrpPrice = (item) => {
        if (item.product_type === 1) {
            if (item.has_many_cs_product_week_day && item.has_many_cs_product_week_day.length > 0) {
                const day = moment().tz(timeZone).format('dddd');
                const dayData = item.has_many_cs_product_week_day.filter((dayitem) => dayitem.pwd_name === day);
                if (dayData.length > 0) {
                    return dayData[0].pwd_mrp;
                } else {
                    return item.has_many_cs_product_week_day[0].pwd_mrp;
                }
            }
        } else {
            return item.product_price;
        }
    }

    return (
        <>
            <AccountHeader heading={'Our Menu'}></AccountHeader>
            <div id="appCapsule"> 
                {isLoadingProducts ?
                    <div className="menuboxsection" >
                        {Array(4)
                            .fill(0)
                            .map((_, productindex) => (
                                <div className="mitembox" key={productindex}>
                                    <div className="mitemboxContent">
                                        <h2 className="title">
                                            <Skeleton width="70%" />
                                        </h2>
                                        <p className="tx-14 sortdec tx-gray">
                                            <Skeleton width="90%" />
                                        </p>
                                        <div className="itemPrice">
                                            <Skeleton width={'50px'} />
                                            <Skeleton width={'50px'} />
                                        </div>
                                    </div>
                                    <div className="mitemboxMedia">
                                        <div className="mitemboxMediaimg">
                                            <Skeleton height={100} width={100} />
                                        </div>
                                        <div className="mitemsQty">
                                            <Skeleton width="50%" height={30} />
                                        </div>
                                        <div className="text-center tx-12 tx-gray mt-0">
                                            <Skeleton width="60%" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                    :
                    productData && productData.length > 0 ? (
                        <div className="menuboxsection"
                        >
                            {
                                productData?.map((productitem, productindex) => (
                                    <div className="mitembox" key={productindex}>
                                        <div className="mitemboxContent">
                                            <h2 className="title">{productitem?.product_name}</h2>
                                            {productitem?.product_content && <p className="tx-14 sortdec tx-gray">{productitem?.product_content}</p>}

                                            <div className="itemPrice">
                                                {parseFloat(sellingPrice(productitem)) && (
                                                    <ins className="new-price">
                                                        ${parseFloat(sellingPrice(productitem))?.toFixed(2)}
                                                    </ins>
                                                )}
                                                {parseFloat(mrpPrice(productitem)) > parseFloat(sellingPrice(productitem)) && (
                                                    <del className="old-price">
                                                        ${parseFloat(mrpPrice(productitem))?.toFixed(2)}
                                                    </del>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mitemboxMedia">
                                            <div className="mitemboxMediaimg">
                                                <img src={productitem?.product_image ? productitem?.product_image : constants.Default_image} alt={productitem?.product_name}></img>
                                            </div>
                                            <div className="mitemsQty">
                                                <div className="mitemcartqty">
                                                    {loadingItemId === productitem.product_id ? (
                                                        <span><Loader type="spinner-default" bgColor={'#db2727'} color={'#db2727'} size={20} /></span>
                                                    ) : (
                                                        <ItemButton
                                                            item={productitem}
                                                            cart={cart}
                                                            onModalOpen={onModalOpen}
                                                            updateCart={updateCartInSession}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {productitem && productitem.product_type === 1 ?
                                                <div className="text-center tx-12 tx-gray mt-0">customisable</div> : ''
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ) :
                        <div className="noimg text-center">
                            <img
                                src="/img/noproduct.png"
                                style={{ width: "250px" }}
                                className="mb-3"
                                alt="Daadi's Kitchen"
                            />
                            <h5>No Product Found</h5>

                            <button
                                className="btn btn-outline-primary  btn-md mt-2"
                                onClick={(e) => {
                                    navigate('/')
                                }}
                            >
                                Go to home
                            </button>
                        </div>
                }
                {contextValues.cartCount && contextValues.cartCount > 0 ?
                    <div className="wapper-footer">
                        <button type="button" className="cfooterbutton" onClick={gotocheckout} >
                            <span>{contextValues.cartCount} Items added</span>
                            <span>View Cart <i className="ri-arrow-right-line"></i></span>
                        </button>
                    </div> : ''}
            </div>
            {contextValues.toggleItemAddModal && <AddItemModal></AddItemModal>}
        </>
    )
}

export default SearchResult